import { render, staticRenderFns } from "./DataSkeleton.vue?vue&type=template&id=7792d503"
import script from "./DataSkeleton.vue?vue&type=script&lang=js"
export * from "./DataSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DataSkeleton.vue?vue&type=style&index=0&id=7792d503&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports